import Box from "@mui/material/Box";
import * as React from "react";

export default function ReadingPage() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Box
        sx={{
          width: "100px",
          height: "100px",
          border: "1px solid rgb(255 222 66)",
          padding: "5px",
        }}
      >
        hie
      </Box>
    </Box>
  );
}
